module.exports = __webpack_public_path__ + "img/boli.0e536955.jpg";